module.exports = __webpack_public_path__ + "static/media/33_tn.4b58ba04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/33_tn.jpg
// module id = 521
// module chunks = 0